import { render, staticRenderFns } from "./AreaDeliveryCost.vue?vue&type=template&id=2331aeee&lang=pug&"
import script from "./AreaDeliveryCost.vue?vue&type=script&lang=ts&"
export * from "./AreaDeliveryCost.vue?vue&type=script&lang=ts&"
import style0 from "./AreaDeliveryCost.vue?vue&type=style&index=0&id=2331aeee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports